const ONBOARDING_OTP_ELIGIBLE_AT_KEY = 'spence_onboarding_otp_eligible_at';

/** Minimum time after verify + OTP send before validate is attempted. */
export const ONBOARDING_OTP_READY_BUFFER_MS = 2000;

const FINCH_VERIFIED_STATE_PATTERN = /finch_verified/i;

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
}

export function markOnboardingOtpEligibleAt(
  bufferMs: number = ONBOARDING_OTP_READY_BUFFER_MS
): void {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.setItem(ONBOARDING_OTP_ELIGIBLE_AT_KEY, String(Date.now() + bufferMs));
}

export function getOnboardingOtpEligibleAt(): number | null {
  const storage = getSessionStorage();
  if (!storage) {
    return null;
  }

  const raw = storage.getItem(ONBOARDING_OTP_ELIGIBLE_AT_KEY);
  if (!raw) {
    return null;
  }

  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

/** When OTP page is opened without a prior mark (refresh), start the buffer from now. */
export function ensureOnboardingOtpEligibleMarked(): void {
  if (getOnboardingOtpEligibleAt() === null) {
    markOnboardingOtpEligibleAt();
  }
}

export function isOnboardingOtpSubmitAllowed(): boolean {
  const eligibleAt = getOnboardingOtpEligibleAt();
  if (eligibleAt === null) {
    return true;
  }

  return Date.now() >= eligibleAt;
}

export function clearOnboardingOtpEligibleAt(): void {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(ONBOARDING_OTP_ELIGIBLE_AT_KEY);
}

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export async function waitUntilOnboardingOtpSubmitAllowed(): Promise<void> {
  const eligibleAt = getOnboardingOtpEligibleAt();
  if (eligibleAt === null) {
    return;
  }

  const waitMs = eligibleAt - Date.now();
  if (waitMs <= 0) {
    return;
  }

  await sleep(waitMs);
}

export function isFinchVerifiedStateError(message: string): boolean {
  return FINCH_VERIFIED_STATE_PATTERN.test(message);
}
